// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3ps2M","header":"ReportDetails_header__1fDu7","title":"ReportDetails_title__1Wozu","left":"ReportDetails_left__3h4sZ"};